import { LOGOUT_RTK } from "@/components/access/ducks/Actions"
import { ClassNoteUserActions } from "@/components/classNotes/ducks/slice"
import { RECEIVE_UPDATE_USER } from "@/components/profile/ducks/Actions"
import { FETCH_USER_SEARCH, SET_SELECTED_USER_URL } from "@/components/search/ducks/Actions"
import { createSlice } from "@reduxjs/toolkit"
import { markAnnouncementsSeen } from "./thunks"

/**
 * @typedef {Object} WelcomeState
 * @property {boolean} updatedOwnProfile
 * @property {boolean} viewSomeonesProfile
 * @property {boolean} searchForMembers
 * @property {boolean} submittedClassNote
 */

/** @type {WelcomeState} */
const initialState = {
  updatedOwnProfile: false,
  viewSomeonesProfile: false,
  searchForMembers: false,
  submittedClassNote: false,
}

const welcomeSlice = createSlice({
  name: "welcome/user",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(LOGOUT_RTK, (_state, _) => initialState)
      .addCase(RECEIVE_UPDATE_USER, (state, _action) => {
        state.updatedOwnProfile = true
      })
      .addCase(FETCH_USER_SEARCH, (state, action) => {
        if (action.params.userInitiated) {
          state.searchForMembers = true
        }
      })
      .addCase(ClassNoteUserActions.submitClassNote.fulfilled, (state, _) => {
        state.submittedClassNote = true
      })
      .addCase(SET_SELECTED_USER_URL, (state, _) => {
        state.viewSomeonesProfile = true
      })
  },
})

export const WelcomeUserActions = {
  ...welcomeSlice.actions,
  markAnnouncementsSeen,
}

export default welcomeSlice.reducer
